import BaseObject from "../../../base/base_object";

export default class BaseFallbackHandler extends BaseObject  {

    _isActive = false;

    init(params){
        super.init(params);
        this.serviceFactory = params.serviceFactory;
    }

    getFallbackName() {
        return 'BaseFallback';
    }

    start() {

    }

    stop() {}
}